/*
 * Copyright (c) 2020. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { HttpNotificationsService } from './http.notifications.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsInterceptorService implements HttpInterceptor {
  constructor(private notificationHttpService: HttpNotificationsService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.notificationHttpService.handleRequest(request);
    return next.handle(request);
  }
}
